import script from "./OrderMaterialDetailDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderMaterialDetailDialog.vue?vue&type=script&setup=true&lang=js"

import "./OrderMaterialDetailDialog.vue?vue&type=style&index=0&id=b76c42c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b76c42c4"]])

export default __exports__